module.exports = __webpack_public_path__ + "76de99394fa365e96e91349581b04ce5.png";